import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./export-button.css";
import { connect } from "react-redux";
import Button from "../basic-button/basic-button";
import { MessageType, NEW_BASE_URL } from "../../../Constant";
import { newReconDownloadExcelAPI } from "../../../services/APIutils";
import { saveExcelBlob } from "../../methods/sharedMethods";
import { Loader } from "../loader/loaderView";
import { addExportBtnPageName, removeExportBtnPageName } from "../../../redux/actions/exportBtnAction";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";

function ExportButton(props) {
  const {
    endpoint, addPageNameHandler, pageName,
    initiateNotification, removePageHandler, exportPagesName,
    isDisable,
  } = props;
  const [isExportBtnLoadaing, setIsExportBtnLoadaing] = React.useState(false);

  const newCreateFormAndSubmit = async ({ uriProps }) => {
    const url = `${NEW_BASE_URL}/v1/${endpoint}`;
    addPageNameHandler(pageName);
    await newReconDownloadExcelAPI(url, uriProps).then((res) => {
      let fileName = res.headers["content-disposition"].split("Filename=")[1];
      fileName = fileName.replaceAll("\"", "");
      saveExcelBlob({ blob: res.data, fileName });
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.log("Error Occured, ", err.message);
      initiateNotification({ type: MessageType.ERROR, message: err.message });
    });
    removePageHandler(pageName);
  };
  const exportCollection = async () => {
    const { query } = props;
    newCreateFormAndSubmit({ uriProps: query });
  };

  useEffect(() => {
    setIsExportBtnLoadaing(exportPagesName.some((item) => item === pageName));
  }, [exportPagesName, pageName]);

  return (
    <span className="exportBtn">
      <Loader loading={isExportBtnLoadaing} />
      <Button
        onClick={() => {
          exportCollection();
        }}
        buttonText="Export"
        disable={isDisable}
      />
    </span>
  );
}

ExportButton.defaultProps = {
  query: {},
  endpoint: "",
  pageName: "",
  isDisable: false,
};
ExportButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  query: PropTypes.object,
  endpoint: PropTypes.string,
  pageName: PropTypes.string,
  isDisable: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  exportPagesName: state.ExportBtnPages.exportBtnPage,
});
const mapDispatchToProps = (dispatch) => ({
  addPageNameHandler: (data) => dispatch(addExportBtnPageName(data)),
  removePageHandler: (data) => dispatch(removeExportBtnPageName(data)),
  initiateNotification: (data) => (dispatch(setNotificationMessage(data))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportButton);
